var developmentEnv = {
  //apiUrl: "http://localhost:8080",
  apiUrl: "https://api.spdata-staging.com.br/chamada-digital",
  brokerUrl: "wss://f1d5j6ry9j.execute-api.us-east-1.amazonaws.com/staging",
  saveLog: true
};
var builtEnv = {
  apiUrl: "https://api.spdata.com.br/chamada-digital",
  brokerUrl: "wss://zjuipwwnze.execute-api.sa-east-1.amazonaws.com/production",
  saveLog: "false" == 'true' || "false" == true
};
export var env = process.env.NODE_ENV === "development" ? developmentEnv : builtEnv;